var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinDocApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 41.634,
    viewBox: "0 0 29 41.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5",
    "data-name": "Group 5",
    transform: "translate(-71 -57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5-2",
    "data-name": "Group 5",
    transform: "translate(73 59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5_Copy",
    "data-name": "Group 5 Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Shape",
    fill: "#072b4f",
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 38.634c-.628 0-1.205-.316-1.544-.844-1.485-2.322-4.36-6.938-6.927-11.772C.692 19.735-1 15.187-1 12.5-1 8.894.404 5.504 2.954 2.954 5.504.404 8.894-1 12.5-1c3.606 0 6.996 1.404 9.546 3.954C24.596 5.504 26 8.894 26 12.5c0 2.687-1.692 7.235-5.03 13.518-2.561 4.824-5.439 9.445-6.926 11.77-.34.53-.916.846-1.544.846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4bc2d4",
    d: "M12.5 0C5.596 0 0 5.596 0 12.5c0 5.912 9.167 20.637 11.798 24.75.154.24.418.384.702.384s.548-.145.702-.384C15.833 33.135 25 18.412 25 12.5 25 5.596 19.404 0 12.5 0m0-2c3.873 0 7.514 1.508 10.253 4.247S27 8.627 27 12.5c0 2.892-1.683 7.467-5.146 13.987-2.579 4.855-5.472 9.503-6.967 11.84-.525.819-1.417 1.307-2.387 1.307s-1.862-.488-2.386-1.305C8.62 35.994 5.73 31.352 3.146 26.487-.317 19.967-2 15.392-2 12.5-2 8.627-.492 4.986 2.247 2.247S8.627-2 12.5-2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__in_our_network",
    "data-name": "in our network",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__check-shield"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-2",
    fill: "#4bc2d4",
    d: "M0 .565A.572.572 0 0 1 .579 0h9.842A.572.572 0 0 1 11 .565v3.54A10.023 10.023 0 0 1 5.5 13 10.019 10.019 0 0 1 0 4.105z",
    "data-name": "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-3",
    fill: "none",
    stroke: "#072b4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
    d: "M5.5 0L1.375 4.333 0 2.786",
    "data-name": "Shape",
    transform: "translate(3.3 3.25)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDocApproved);
export default __webpack_public_path__ + "static/media/pin-doc-approved.c268a937605f9a9f94fc4c1971e0d7f9.svg";
export { ForwardRef as ReactComponent };